import type { GpsReading } from '../domain/telemetry/raw/GpsReading'
import type { Finding } from './finding'
import type { GpsFixReading } from './gpsFix'
import type { GpsStreamTrust } from './streamChecks/gpsStreamTrust'
import { runGpsStreamChecks } from './streamChecks/runGpsStreamChecks'
import { KMH_PER_MPS } from '../utils/speedUnits'

export interface GpsVerdicts {
  timeTrusted: boolean
  speedTrusted: boolean
  reportedSpeedIsWrong: boolean
}

export const gpsFixOf = (reading: GpsReading): GpsFixReading => ({
  timeMs: reading.timestamp.getTime(),
  latitude: reading.latitude,
  longitude: reading.longitude,
  speedKmh:
    reading.speedMs === undefined ? undefined : reading.speedMs * KMH_PER_MPS,
})

export function checkGpsReadings(readings: readonly GpsReading[]): {
  trust: GpsStreamTrust
  findings: Finding[]
  verdicts: GpsVerdicts
} {
  const { trust, findings } = runGpsStreamChecks(readings.map(gpsFixOf))
  return {
    trust,
    findings,
    verdicts: {
      timeTrusted: trust.timeTrusted,
      speedTrusted: trust.speedTrusted,
      reportedSpeedIsWrong: findings.some(
        (finding) =>
          finding.aspect === 'gpsSpeed' && finding.verdict === 'unreliable'
      ),
    },
  }
}
